import { getAllPlaybooksToolSignature, addContactToPlaybookToolSignature } from './get-all-playbooks-tool-signature';
import { getInsideNetworkRecommendationsToolSignature } from './get-inside-network-recommendations-tool-signature';
import { getUserLinkedinProfileToolSignature } from './get-user-linkedin-profile-tool-signature';
import { webSearchToolSignature } from './web-search-tool-signature';
import {
    searchLinkedinNetworkRegexToolSignature,
    searchLinkedinNetworkEmbeddingToolSignature,
} from './search-linkedin-network-tool-signature';
import {
    getUsersConversationsToolSignature,
    searchConversationsToolSignature,
    searchForMessagesToolSignature,
} from './conversations-tools-signature';
import { getMyCompanyOfferingSummaryToolSignature } from './get-my-company-offering-summary-tool-signature';
import { getUsersLinkedinPostsToolSignature } from './get-users-linkedin-posts-tool-signature';
import { getLinkedinPostsLikesAndCommentsToolSignature } from './get-linkedin-posts-comments-tool-signature';
import { getProspectsInfoToolSignature } from './get-prospects-info-tool-signature';
import { getActionsToolSignature, searchActionsToolSignature } from './actions-tools-signature';
import { displayProfilesToolSignature } from './display-profiles-tool-signature';
import { userSelectionDisplayToolSignature } from './user-selection-tool-signature';
import { ToolSignature } from './tool-signature';
import { getLinkedinNetworkProfilesSummaryToolSignature } from './search-linkedin-network-tool-signature';
import { LinkedinNetworkAnalysisToolSignature } from './search-linkedin-network-tool-signature';
import { displayPlaybooksToolSignature } from './display-playbooks-tool-signature';
import { updatePlaybooksToolSignature } from './update-playbooks-tool-signature';
import { createPlaybookToolSignature } from './create-playbook-signature';
import { displayConversationToolSignature } from './display-chats-tool-signature';
import { searchMyAssignedContactsToolSignature } from './search-my-assigned-contacts-tool-signature';
import { thinkToolSignature } from './think-tool-signature';
import { updateWorkingMemoryToolSignature } from './update-working-memory-tool-signature';
import { getDealsToolSignature } from './crm-signatures';

export const mocks = {
    prospectIds: ['67dd5e4591a7b1b0945882b1', '67f4af98bfa015bbdb513dfb', '681b3a9b90c3bfe74311605b'],
    groupIds: ['7c5c665e-02fd-43b0-b79d-5f88c1605b5d'],
};

/**
 * Array of all tool signatures.
 * This is used by the client to register UI components for each tool.
 */
export const allToolSignatures = [
    getAllPlaybooksToolSignature,
    getInsideNetworkRecommendationsToolSignature,
    getUserLinkedinProfileToolSignature,
    webSearchToolSignature,
    searchLinkedinNetworkEmbeddingToolSignature,
    searchLinkedinNetworkRegexToolSignature,
    LinkedinNetworkAnalysisToolSignature,
    searchConversationsToolSignature,
    getMyCompanyOfferingSummaryToolSignature,
    getUsersLinkedinPostsToolSignature,
    getLinkedinPostsLikesAndCommentsToolSignature,
    getProspectsInfoToolSignature,
    addContactToPlaybookToolSignature,
    searchForMessagesToolSignature,
    getActionsToolSignature,
    searchActionsToolSignature,
    displayProfilesToolSignature,
    userSelectionDisplayToolSignature,
    getLinkedinNetworkProfilesSummaryToolSignature,
    displayPlaybooksToolSignature,
    updatePlaybooksToolSignature,
    createPlaybookToolSignature,
    displayConversationToolSignature,
    searchMyAssignedContactsToolSignature,
    thinkToolSignature,
    updateWorkingMemoryToolSignature,
    searchLinkedinNetworkRegexToolSignature,
    getUsersConversationsToolSignature,
    getDealsToolSignature,
] as ToolSignature[];
